
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2FMo5", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<049819a7ef48d0ee11ca5d6be7b649e3>>
 * @relayHash a05c0aaf67cd8f0c10738234127dfc9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0bef23b817246ce96047fb5a9ba545e88b4f5b96ddbaeec83d7ff9aa7a775b17
const $1977b0ed7f082cb5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateDefaultTitleEmojiPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateDefaultTitleEmoji",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceUpdateDefaultTitleEmojiPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateDefaultTitleEmoji",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a05c0aaf67cd8f0c10738234127dfc9a",
            "id": "0bef23b817246ce96047fb5a9ba545e88b4f5b96ddbaeec83d7ff9aa7a775b17",
            "metadata": {},
            "name": "EmojiTitleButtonUpdateDefaultTitleEmojiMutation",
            "operationKind": "mutation",
            "text": "mutation EmojiTitleButtonUpdateDefaultTitleEmojiMutation($cloudId:ID!,$input:ConfluenceUpdateDefaultTitleEmojiInput!){confluence_updateDefaultTitleEmoji(cloudId:$cloudId,input:$input){contentId,success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$1977b0ed7f082cb5$var$node.hash = "576a3256d35e9e9e85e6a3da9d2bd499";
var $1977b0ed7f082cb5$export$2e2bcd8739ae039 = $1977b0ed7f082cb5$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $ecUYt = parcelRequire("ecUYt");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $AV9gd = parcelRequire("AV9gd");


var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");











var $aXWIB = parcelRequire("aXWIB");


var $hmuev = parcelRequire("hmuev");


var $eEA8O = parcelRequire("eEA8O");


var $lGgRw = parcelRequire("lGgRw");


var $9eEg2 = parcelRequire("9eEg2");


var $9pS9R = parcelRequire("9pS9R");


var $9hlns = parcelRequire("9hlns");





var $f0NfR = parcelRequire("f0NfR");





var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");




/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $3e1d3e4629826485$export$ffdfa071c8ed90a6 = /*#__PURE__*/ function(ConfluenceGraphQLDefaultTitleEmoji) {
    ConfluenceGraphQLDefaultTitleEmoji["LIVE_PAGE_DEFAULT"] = "LIVE_PAGE_DEFAULT";
    ConfluenceGraphQLDefaultTitleEmoji["NONE"] = "NONE";
    return ConfluenceGraphQLDefaultTitleEmoji;
}({});





const $9a23949174eb14aa$var$i18n = (0, $aXWIB.defineMessages)({
    removeEmoji: {
        id: "emoji-title.remove-emoji",
        defaultMessage: "Remove emoji"
    },
    emojiLabel: {
        id: "emoji-title.add-emoji.floating-toolbar",
        defaultMessage: "Emoji"
    },
    restoreEmoji: {
        id: "emoji-title.restore-emoji",
        defaultMessage: "Restore emoji"
    }
});
const $9a23949174eb14aa$var$emojiIconStyles = null;
const $9a23949174eb14aa$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const $ = (0, $frIzR.c)(9);
    let otherProps;
    let style;
    if ($[0] !== props) {
        ({ style: style, ...otherProps } = props);
        $[0] = props;
        $[1] = otherProps;
        $[2] = style;
    } else {
        otherProps = $[1];
        style = $[2];
    }
    let t0;
    if ($[3] !== style) {
        t0 = {
            ...style
        };
        $[3] = style;
        $[4] = t0;
    } else t0 = $[4];
    let t1;
    if ($[5] !== otherProps || $[6] !== ref || $[7] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...otherProps,
            ref: ref,
            style: t0
        });
        $[5] = otherProps;
        $[6] = ref;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
});
const $9a23949174eb14aa$var$EmojiTitlePopoverComponent = (t0)=>{
    const $ = (0, $frIzR.c)(77);
    const { contentId: contentId, hasEmoji: hasEmoji, onRemoveEmoji: onRemoveEmoji, isLoading: isLoading, emojiPicker: emojiPicker, setOpenSecondEmojiPicker: setOpenSecondEmojiPicker, setIsEmojiButtonFocused: setIsEmojiButtonFocused, openSecondEmojiPicker: openSecondEmojiPicker, onEmojiPickerLoaded: onEmojiPickerLoaded, userOffline: userOffline, floatingToolbarButtonStyle: floatingToolbarButtonStyle, updateDefaultEmoji: updateDefaultEmoji, hasLiveDocsDefaultEmoji: hasLiveDocsDefaultEmoji, autoPageEmojiCohort: autoPageEmojiCohort, emojiTitleDiscovered: emojiTitleDiscovered, contentType: contentType, previousEmojiId: previousEmojiId, restorePreviousEmoji: restorePreviousEmoji, aifcSuggestionInFlight: aifcSuggestionInFlight, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, currentEmojiId: currentEmojiId, aiEmojiSuggestionSource: aiEmojiSuggestionSource, aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isInRandomEmojiCohort = autoPageEmojiCohort && autoPageEmojiCohort === "random";
    let t1;
    let t2;
    if ($[0] !== onEmojiPickerLoaded) {
        t1 = ()=>{
            onEmojiPickerLoaded && onEmojiPickerLoaded();
        };
        t2 = [
            onEmojiPickerLoaded
        ];
        $[0] = onEmojiPickerLoaded;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    const [aifcEmojiHasLandedOnce, setAifcEmojiHasLandedOnce] = (0, $42omo.useState)(false);
    let t3;
    let t4;
    if ($[3] !== hasEmoji) {
        t3 = ()=>{
            if (hasEmoji) setAifcEmojiHasLandedOnce(true);
        };
        t4 = [
            hasEmoji
        ];
        $[3] = hasEmoji;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    const hasRemovedAIFCEmojiRef = (0, $42omo.useRef)(false);
    const hasRemovedBlankPageAutoEmojiRef = (0, $42omo.useRef)(false);
    const hasRemovedSuggestTitleEmojiRef = (0, $42omo.useRef)(false);
    const hasFiredAifcSuggestionLandedRef = (0, $42omo.useRef)(false);
    let t5;
    let t6;
    if ($[6] !== aiEmojiSuggestionSessionId) {
        t5 = ()=>{
            if (aiEmojiSuggestionSessionId !== undefined) {
                hasRemovedAIFCEmojiRef.current = false;
                hasRemovedBlankPageAutoEmojiRef.current = false;
                hasRemovedSuggestTitleEmojiRef.current = false;
                hasFiredAifcSuggestionLandedRef.current = false;
            }
        };
        t6 = [
            aiEmojiSuggestionSessionId
        ];
        $[6] = aiEmojiSuggestionSessionId;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[9] !== contentId || $[10] !== createAnalyticsEvent || $[11] !== isLivePage) {
        t7 = (t8)=>{
            const { element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: t9 } = t8;
            const attributes = t9 === undefined ? {} : t9;
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: "EmojiTitlePopover",
                    attributes: {
                        contentId: contentId,
                        element: element,
                        isLivePage: isLivePage,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[9] = contentId;
        $[10] = createAnalyticsEvent;
        $[11] = isLivePage;
        $[12] = t7;
    } else t7 = $[12];
    const sendAnalyticsEvent = t7;
    let t8;
    let t9;
    if ($[13] !== aiEmojiSuggestionSource || $[14] !== aiSuggestedEmojiId || $[15] !== autoPageEmojiCohort || $[16] !== contentType || $[17] !== currentEmojiId || $[18] !== hasEmoji || $[19] !== isSmartCreate || $[20] !== sendAnalyticsEvent) {
        t8 = ()=>{
            if (hasEmoji && !hasFiredAifcSuggestionLandedRef.current && isSmartCreate && !!aiSuggestedEmojiId && currentEmojiId === aiSuggestedEmojiId) {
                hasFiredAifcSuggestionLandedRef.current = true;
                sendAnalyticsEvent({
                    element: "pageEmoji",
                    action: "set",
                    actionSubject: "pageEmoji",
                    actionSubjectId: "aifcSuggestionLanded",
                    attributes: {
                        source: "EmojiTitlePopover",
                        cohort: autoPageEmojiCohort,
                        contentType: contentType,
                        aiSuggestedEmojiId: aiSuggestedEmojiId,
                        aiEmojiSuggestionSource: aiEmojiSuggestionSource
                    }
                });
            }
        };
        t9 = [
            hasEmoji,
            isSmartCreate,
            aiSuggestedEmojiId,
            currentEmojiId,
            sendAnalyticsEvent,
            autoPageEmojiCohort,
            contentType,
            aiEmojiSuggestionSource
        ];
        $[13] = aiEmojiSuggestionSource;
        $[14] = aiSuggestedEmojiId;
        $[15] = autoPageEmojiCohort;
        $[16] = contentType;
        $[17] = currentEmojiId;
        $[18] = hasEmoji;
        $[19] = isSmartCreate;
        $[20] = sendAnalyticsEvent;
        $[21] = t8;
        $[22] = t9;
    } else {
        t8 = $[21];
        t9 = $[22];
    }
    (0, $42omo.useEffect)(t8, t9);
    const isAifcLoadingRemoveDisable = !!aifcSuggestionInFlight && !hasEmoji && !aifcEmojiHasLandedOnce;
    const shouldShowRemoveVariant = hasEmoji || hasLiveDocsDefaultEmoji || isAifcLoadingRemoveDisable;
    let t10;
    if ($[23] !== contentType || $[24] !== createAnalyticsEvent || $[25] !== emojiTitleDiscovered || $[26] !== isInRandomEmojiCohort || $[27] !== isLivePage || $[28] !== setOnboardingState) {
        t10 = ()=>{
            if (isInRandomEmojiCohort && !emojiTitleDiscovered) {
                setOnboardingState({
                    key: (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED,
                    value: "true"
                });
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "completed",
                        actionSubject: "emojiTitleDiscoveredOnboarding",
                        source: "EmojiTitlePopover",
                        attributes: {
                            cohort: "random",
                            contentType: contentType,
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
        };
        $[23] = contentType;
        $[24] = createAnalyticsEvent;
        $[25] = emojiTitleDiscovered;
        $[26] = isInRandomEmojiCohort;
        $[27] = isLivePage;
        $[28] = setOnboardingState;
        $[29] = t10;
    } else t10 = $[29];
    const setEmojiTitleDiscoveredOnboardingState = t10;
    let t11;
    if ($[30] !== setIsEmojiButtonFocused) {
        t11 = ()=>{
            setIsEmojiButtonFocused(true);
        };
        $[30] = setIsEmojiButtonFocused;
        $[31] = t11;
    } else t11 = $[31];
    const handleFocus = t11;
    let t12;
    if ($[32] !== setIsEmojiButtonFocused) {
        t12 = ()=>{
            setIsEmojiButtonFocused(false);
        };
        $[32] = setIsEmojiButtonFocused;
        $[33] = t12;
    } else t12 = $[33];
    const handleBlur = t12;
    let t13;
    if ($[34] !== autoPageEmojiCohort || $[35] !== contentType || $[36] !== openSecondEmojiPicker || $[37] !== sendAnalyticsEvent || $[38] !== setOpenSecondEmojiPicker) {
        t13 = ()=>{
            sendAnalyticsEvent({
                element: "button",
                action: "clicked",
                actionSubject: "addEmojiButton",
                actionSubjectId: "EmojiTitlePopover-addEmoji",
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType
                }
            });
            setOpenSecondEmojiPicker(!openSecondEmojiPicker);
            sendAnalyticsEvent({
                element: "button",
                action: "opened",
                actionSubject: "emojiPicker",
                actionSubjectId: "emojiPicker_opened",
                attributes: {
                    triggerType: "addEmojiButton, changeEmojiButton",
                    inputMethod: "title",
                    cohort: autoPageEmojiCohort,
                    contentType: contentType
                }
            });
        };
        $[34] = autoPageEmojiCohort;
        $[35] = contentType;
        $[36] = openSecondEmojiPicker;
        $[37] = sendAnalyticsEvent;
        $[38] = setOpenSecondEmojiPicker;
        $[39] = t13;
    } else t13 = $[39];
    const openSecondEmojiPickerWithAnalytics = t13;
    let t14;
    if ($[40] !== autoPageEmojiCohort || $[41] !== contentId || $[42] !== contentType || $[43] !== createAnalyticsEvent || $[44] !== isLivePage || $[45] !== previousEmojiId || $[46] !== restorePreviousEmoji || $[47] !== updateDefaultEmoji) {
        t14 = ()=>{
            const hasRestorablePreviousEmoji = !!previousEmojiId && previousEmojiId !== (0, $8rneB.DefaultTitleEmojiValues).LIVE_PAGE_DEFAULT && !!restorePreviousEmoji && (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_livedocs_restore_latest_emoji");
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "restoreEmojiButton",
                    actionSubjectId: "restoreEmojiButton_clicked",
                    source: "EmojiTitlePopover",
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage,
                        cohort: autoPageEmojiCohort,
                        contentType: contentType,
                        restoredFromPreviousEmoji: hasRestorablePreviousEmoji
                    }
                }
            }).fire();
            if (hasRestorablePreviousEmoji && restorePreviousEmoji) {
                restorePreviousEmoji();
                return;
            }
            updateDefaultEmoji({
                defaultTitleEmoji: (0, $3e1d3e4629826485$export$ffdfa071c8ed90a6).LIVE_PAGE_DEFAULT
            });
        };
        $[40] = autoPageEmojiCohort;
        $[41] = contentId;
        $[42] = contentType;
        $[43] = createAnalyticsEvent;
        $[44] = isLivePage;
        $[45] = previousEmojiId;
        $[46] = restorePreviousEmoji;
        $[47] = updateDefaultEmoji;
        $[48] = t14;
    } else t14 = $[48];
    const restoreDefaultEmoji = t14;
    let t15;
    if ($[49] !== emojiPicker) {
        t15 = ()=>emojiPicker;
        $[49] = emojiPicker;
        $[50] = t15;
    } else t15 = $[50];
    let t16;
    if ($[51] !== aiEmojiSuggestionSource || $[52] !== aiSuggestedEmojiId || $[53] !== autoPageEmojiCohort || $[54] !== contentType || $[55] !== currentEmojiId || $[56] !== floatingToolbarButtonStyle || $[57] !== handleBlur || $[58] !== handleFocus || $[59] !== intl || $[60] !== isAifcLoadingRemoveDisable || $[61] !== isLivePage || $[62] !== isLoading || $[63] !== isSmartCreate || $[64] !== onRemoveEmoji || $[65] !== openSecondEmojiPicker || $[66] !== openSecondEmojiPickerWithAnalytics || $[67] !== restoreDefaultEmoji || $[68] !== sendAnalyticsEvent || $[69] !== setEmojiTitleDiscoveredOnboardingState || $[70] !== shouldShowRemoveVariant || $[71] !== userOffline) {
        t16 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "emoji-popup-button",
                className: "emoji-popup-button",
                onFocus: handleFocus,
                onBlur: handleBlur
            }, shouldShowRemoveVariant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ref: triggerProps.ref,
                "aria-controls": triggerProps["aria-controls"],
                "data-ds--level": triggerProps["data-ds--level"],
                style: floatingToolbarButtonStyle || {},
                appearance: "subtle",
                "data-testid": "emoji-remove-button",
                id: "emoji-popup-button",
                isDisabled: isLoading || userOffline || isAifcLoadingRemoveDisable,
                spacing: "compact",
                onClick: (event)=>{
                    onRemoveEmoji(event);
                    setEmojiTitleDiscoveredOnboardingState();
                    const removedAIFCSuggestedEmoji = !hasRemovedAIFCEmojiRef.current && !!isSmartCreate && !!aiSuggestedEmojiId && currentEmojiId === aiSuggestedEmojiId;
                    if (removedAIFCSuggestedEmoji) hasRemovedAIFCEmojiRef.current = true;
                    const removedBlankPageAutoPasteSuggestedEmoji = !hasRemovedBlankPageAutoEmojiRef.current && aiEmojiSuggestionSource === "pasteAutoTitle" && !!aiSuggestedEmojiId && currentEmojiId === aiSuggestedEmojiId;
                    if (removedBlankPageAutoPasteSuggestedEmoji) hasRemovedBlankPageAutoEmojiRef.current = true;
                    const removedSuggestTitleSuggestedEmoji = !hasRemovedSuggestTitleEmojiRef.current && aiEmojiSuggestionSource === "suggestTitle" && !!aiSuggestedEmojiId && currentEmojiId === aiSuggestedEmojiId;
                    if (removedSuggestTitleSuggestedEmoji) hasRemovedSuggestTitleEmojiRef.current = true;
                    sendAnalyticsEvent({
                        element: "button",
                        action: "clicked",
                        actionSubject: "removeEmojiButton",
                        actionSubjectId: "EmojiTitlePopover-removeEmoji",
                        attributes: {
                            cohort: autoPageEmojiCohort,
                            contentType: contentType,
                            removedAIFCSuggestedEmoji: removedAIFCSuggestedEmoji,
                            removedBlankPageAutoPasteSuggestedEmoji: removedBlankPageAutoPasteSuggestedEmoji,
                            removedSuggestTitleSuggestedEmoji: removedSuggestTitleSuggestedEmoji,
                            aiEmojiSuggestionSource: aiEmojiSuggestionSource
                        }
                    });
                },
                iconBefore: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                    size: "small",
                    interactionName: "emoji-title-popover"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    className: (0, $gMc0m.default)([
                        "_lcxvglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                    label: "",
                    size: "small"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "emoji-popup-button-text"
            }, intl.formatMessage($9a23949174eb14aa$var$i18n.removeEmoji))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ref: triggerProps.ref,
                "aria-controls": triggerProps["aria-controls"],
                "data-ds--level": triggerProps["data-ds--level"],
                style: floatingToolbarButtonStyle || {},
                appearance: "subtle",
                "data-testid": "emoji-add-button",
                id: "emoji-popup-button",
                isDisabled: isLoading || userOffline,
                spacing: "compact",
                isSelected: openSecondEmojiPicker,
                onClick: ()=>{
                    isLivePage ? restoreDefaultEmoji() : openSecondEmojiPickerWithAnalytics();
                    setEmojiTitleDiscoveredOnboardingState();
                },
                iconBefore: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                    size: "small",
                    interactionName: "emoji-title-popover"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    className: (0, $gMc0m.default)([
                        "_lcxvglyw"
                    ])
                }, isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9pS9R))), {
                    label: "",
                    testId: "restore-icon"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9eEg2))), {
                    label: "",
                    testId: "add-emoji-icon"
                }))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: "emoji-popup-button-text"
            }, isLivePage ? intl.formatMessage($9a23949174eb14aa$var$i18n.restoreEmoji) : intl.formatMessage($9a23949174eb14aa$var$i18n.emojiLabel))));
        $[51] = aiEmojiSuggestionSource;
        $[52] = aiSuggestedEmojiId;
        $[53] = autoPageEmojiCohort;
        $[54] = contentType;
        $[55] = currentEmojiId;
        $[56] = floatingToolbarButtonStyle;
        $[57] = handleBlur;
        $[58] = handleFocus;
        $[59] = intl;
        $[60] = isAifcLoadingRemoveDisable;
        $[61] = isLivePage;
        $[62] = isLoading;
        $[63] = isSmartCreate;
        $[64] = onRemoveEmoji;
        $[65] = openSecondEmojiPicker;
        $[66] = openSecondEmojiPickerWithAnalytics;
        $[67] = restoreDefaultEmoji;
        $[68] = sendAnalyticsEvent;
        $[69] = setEmojiTitleDiscoveredOnboardingState;
        $[70] = shouldShowRemoveVariant;
        $[71] = userOffline;
        $[72] = t16;
    } else t16 = $[72];
    let t17;
    if ($[73] !== openSecondEmojiPicker || $[74] !== t15 || $[75] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            "data-testid": "emoji-popup",
            isOpen: openSecondEmojiPicker,
            autoFocus: false,
            popupComponent: $9a23949174eb14aa$var$PopupComponent,
            onClose: $9a23949174eb14aa$var$_temp,
            content: t15,
            trigger: t16,
            placement: "bottom-start",
            zIndex: 700
        });
        $[73] = openSecondEmojiPicker;
        $[74] = t15;
        $[75] = t16;
        $[76] = t17;
    } else t17 = $[76];
    return t17;
};
const $9a23949174eb14aa$export$d1f4a31666fe9f85 = (0, $f0NfR.withSessionData)($9a23949174eb14aa$var$EmojiTitlePopoverComponent);
$9a23949174eb14aa$export$d1f4a31666fe9f85.displayName = 'EmojiTitlePopover';
function $9a23949174eb14aa$var$_temp() {}



var $ktUCG = parcelRequire("ktUCG");


var $5DJsZ = parcelRequire("5DJsZ");



var $308Wd = parcelRequire("308Wd");


var $gxtki = parcelRequire("gxtki");

const $edc85dfc7a3f85c2$var$EmojiTitleButtonUpdateDefaultTitleEmojiMutation = (0, $1977b0ed7f082cb5$export$2e2bcd8739ae039);
const $edc85dfc7a3f85c2$var$processDefaultTitleMutationError = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $edc85dfc7a3f85c2$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkv77o _u5f312x7 _1tke1ylp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $edc85dfc7a3f85c2$var$EmojiTitleButtonComponent = ({ contentId: contentId, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, emojiTitleState: emojiTitleState, setSelectedEmoji: setSelectedEmoji, onEmojiPickerLoaded: onEmojiPickerLoaded, isUnpublishedDraft: isUnpublishedDraft, disableEmoji: disableEmoji, floatingToolbarButtonStyle: floatingToolbarButtonStyle, pageTreeStateUpdater: pageTreeStateUpdater, contentType: contentType, autoPageEmojiCohort: autoPageEmojiCohort, emojiTitleDiscovered: emojiTitleDiscovered, aifcSuggestionInFlight: aifcSuggestionInFlight, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, aiEmojiSuggestionSource: aiEmojiSuggestionSource, aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const emojiStatusFieldName = (0, $5amrO.useEmojiStatusFieldName)();
    const [defaulTitleEmojiMutationError, setDefaulTitleEmojiMutationError] = (0, $42omo.useState)(null);
    const setSelectedEmojiCallback = (0, $42omo.useCallback)((emoji)=>{
        setSelectedEmoji && setSelectedEmoji(emoji);
    }, [
        setSelectedEmoji
    ]);
    const [savedEmoji, setSavedEmoji] = (0, $42omo.useState)(null);
    const hasReplacedAIFCEmojiRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (aiEmojiSuggestionSessionId !== undefined) hasReplacedAIFCEmojiRef.current = false;
    }, [
        aiEmojiSuggestionSessionId
    ]);
    const closeBothEmojiPicker = ()=>{
        emojiTitleState.setOpenFirstEmojiPicker(false);
        emojiTitleState.setOpenSecondEmojiPicker(false);
    };
    const updateIsRemovingEmoji = ()=>{
        emojiTitleState.setIsRemovingEmoji(true);
    };
    const onClickInEditor = (0, $42omo.useCallback)((event)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- only invoked client-side from a document click listener
        const emojiDialog = document.getElementById('emoji-picker');
        const EMOJI_POPUP_BUTTOM_ID = 'emoji-popup-button';
        const shouldCloseDialog = !(event.target?.classList?.contains('emoji') || event.target?.classList?.contains('emoji-common-emoji-sprite') || event.target?.classList?.contains('emoji-popup-button-text') || event.target?.getAttribute('aria-label') === 'Add emoji' || event.target?.parentNode?.classList?.contains('cover-picture') || event.target?.getAttribute('aria-label') === 'Emoji' || event.target?.classList?.contains('add-picture-button') || event.target?.getAttribute('id') === EMOJI_POPUP_BUTTOM_ID || event.target?.parentNode?.getAttribute('id') === EMOJI_POPUP_BUTTOM_ID || event.target?.parentNode?.classList?.contains(EMOJI_POPUP_BUTTOM_ID) || event.target?.parentNode?.classList?.contains('emoji-picker-add-emoji') || event.target?.classList?.contains('add-picture-button') || event.target?.getAttribute('aria-label') === 'image icon' || // The following attributes come from EmojiTitleSelection and are used to ensure
        // the default icon's elements and its container are not registered as editor clicks
        event.target?.parentNode?.getAttribute('data-testid') === 'live-docs-default-title-icon' || event.target?.getAttribute('data-testid') === 'live-docs-default-title-icon');
        if (!emojiDialog?.contains(event.target) && shouldCloseDialog) closeBothEmojiPicker();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        // handle close emoji picker when user click outside the picker dialog
        document.addEventListener('click', onClickInEditor);
        return ()=>{
            document.removeEventListener('click', onClickInEditor);
            closeBothEmojiPicker();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (isUnpublishedDraft) // track draft created with emoji
            (0, $3shHM.trackDraftCreatedWithEmoji)({
                createAnalyticsEvent: createAnalyticsEvent,
                contentId: contentId,
                isLivePage: isLivePage
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isUnpublishedDraft
    ]);
    const { data: data, error: error, refetch: refetchEmoji } = (0, $jMyy4.useQueryInterop)((0, $5DJsZ.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "@confluence/emoji-title"
    });
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: updateEmojiLoading } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: [
                {
                    query: (0, $5DJsZ.default),
                    variables: {
                        contentId: contentId,
                        status: [
                            'current',
                            'draft'
                        ],
                        skipPublishedFragment: false,
                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                    }
                }
            ]
        }
    });
    const [updateDefaultTitleEmojiMutation, { loading: updateDefaultTitleEmojiLoading }] = (0, $308Wd.useMutationInterop)($edc85dfc7a3f85c2$var$EmojiTitleButtonUpdateDefaultTitleEmojiMutation, {
        refetchQueries: [
            {
                query: (0, $5DJsZ.default),
                variables: {
                    contentId: contentId,
                    status: [
                        'current',
                        'draft'
                    ],
                    skipPublishedFragment: false,
                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                }
            }
        ],
        awaitRefetchQueries: true,
        __callerPackage__: "@confluence/emoji-title"
    });
    const updateDefaultEmoji = (0, $42omo.useCallback)(async ({ defaultTitleEmoji: defaultTitleEmoji, onUpdateComplete: onUpdateComplete })=>{
        if (!isLivePage) return;
        try {
            emojiTitleState.setIsUpdatingEmoji(true);
            const { data: mutationData } = await updateDefaultTitleEmojiMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        contentId: contentId,
                        defaultTitleEmoji: defaultTitleEmoji
                    }
                }
            });
            const result = mutationData?.confluence_updateDefaultTitleEmoji;
            if (result?.success) {
                emojiTitleState.setHasLiveDocsDefaultEmoji(defaultTitleEmoji === 'LIVE_PAGE_DEFAULT');
                setDefaulTitleEmojiMutationError(null);
                onUpdateComplete?.();
            }
            if (result?.errors?.length && result?.errors?.length > 0) {
                const transformedErrors = (0, $gxtki.mutationErrorExtensionsAggCompat)(result.errors);
                transformedErrors.forEach((mutationError)=>{
                    if (mutationError.message && mutationError.extensions && mutationError.extensions[0]?.statusCode) {
                        const parsedError = new Error(mutationError.message || 'Unknown error');
                        setDefaulTitleEmojiMutationError(parsedError);
                        $edc85dfc7a3f85c2$var$processDefaultTitleMutationError(parsedError, contentId);
                    }
                });
            }
        } catch (gqlError) {
            setDefaulTitleEmojiMutationError(gqlError);
            $edc85dfc7a3f85c2$var$processDefaultTitleMutationError(gqlError, contentId);
            (0, $7Sm4c.markErrorAsHandled)(gqlError);
        } finally{
            emojiTitleState.setIsUpdatingEmoji(false);
        }
    }, [
        isLivePage,
        contentId,
        cloudId,
        updateDefaultTitleEmojiMutation,
        emojiTitleState
    ]);
    const refetchEmojiAndUpdatePageTreeSubscription = (0, $42omo.useCallback)(async ()=>{
        await refetchEmoji();
        if (isLivePage) pageTreeStateUpdater.setForceFetchPageId(contentId);
    }, [
        refetchEmoji,
        isLivePage,
        pageTreeStateUpdater,
        contentId
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'emojiTitleUpdated',
        subscriberId: 'emojiTitleButton',
        onDataReceived: refetchEmojiAndUpdatePageTreeSubscription
    });
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'emojiTitleDeleted',
        subscriberId: 'emojiTitleButtonDeleted',
        onDataReceived: refetchEmojiAndUpdatePageTreeSubscription
    });
    const hasEmoji = !!(data && (0, $8rneB.getHasEmoji)(data, emojiStatusFieldName));
    const emojiId = (data && (0, $8rneB.getEmojiId)(data, emojiStatusFieldName)) ?? '';
    const hasDefaultTitleEmoji = isLivePage && (0, $8rneB.getHasLiveDocsDefaultEmoji)(data);
    const removeEmojiCallback = async (event)=>{
        setSavedEmoji(null);
        setSelectedEmojiCallback(null);
        closeBothEmojiPicker();
        updateIsRemovingEmoji();
        if (isLivePage) {
            // Default Emoji Removal
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'removeDefaultEmojiButton',
                    actionSubjectId: 'removeDefaultEmojiButton_clicked',
                    source: 'EmojiTitleButton',
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage,
                        hasLiveDocsDefaultEmoji: hasDefaultTitleEmoji
                    }
                }
            }).fire();
            updateDefaultEmoji({
                defaultTitleEmoji: (0, $3e1d3e4629826485$export$ffdfa071c8ed90a6).NONE
            });
        }
        if (hasEmoji) await (0, $brn6e.onRemoveEmoji)(event, {
            onUpdateStartEmoji: onUpdateStartEmoji,
            onUpdateEndEmoji: onUpdateEndEmoji,
            onEmojiUpdated: refetchEmoji,
            contentId: contentId,
            updateContentProperty: updateContentProperty,
            componentName: 'EmojiTitleButton',
            emojiStatusFieldName: emojiStatusFieldName
        });
        else // Handle clean up if not handled in onRemoveEmoji call
        onUpdateEndEmoji?.();
    }; // Restore the cached emoji via the normal set-emoji flow (not the
    // live-page-default sentinel). Silently bails so the caller falls back
    // to the Live Docs default.
    const restorePreviousEmoji = (0, $42omo.useCallback)(async ()=>{
        const previousEmojiId = emojiTitleState.getPreviousEmojiId(contentId);
        if (!previousEmojiId || previousEmojiId === (0, $8rneB.DefaultTitleEmojiValues).LIVE_PAGE_DEFAULT || !userId) return;
         // One provider for both lookup and onSelectEmoji (getEmojiFromEmojiId
        // would internally construct a second instance).
        const emojiProvider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
        if (!emojiProvider) return;
        const previousEmojiDescription = await emojiProvider.findById(previousEmojiId);
        if (!previousEmojiDescription) return;
         // `loadMediaEmoji` returns null for standard Unicode emojis — fall back to the description.
        const previousEmoji = await emojiProvider.loadMediaEmoji(previousEmojiDescription) ?? previousEmojiDescription;
        await (0, $brn6e.onSelectEmoji)({
            selectedEmoji: previousEmoji,
            emojiProvider: emojiProvider,
            onUpdateStartEmoji: onUpdateStartEmoji,
            createAnalyticsEvent: createAnalyticsEvent,
            emojiTitleState: emojiTitleState,
            onEmojiUpdated: refetchEmoji,
            onUpdateEndEmoji: onUpdateEndEmoji,
            updateContentProperty: updateContentProperty,
            contentId: contentId,
            componentName: 'EmojiTitleButton',
            isLivePage: isLivePage,
            emojiStatusFieldName: emojiStatusFieldName
        }, null);
    }, [
        emojiTitleState,
        userId,
        cloudId,
        onUpdateStartEmoji,
        createAnalyticsEvent,
        refetchEmoji,
        onUpdateEndEmoji,
        updateContentProperty,
        contentId,
        isLivePage,
        emojiStatusFieldName
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasEmoji && emojiId.length > 0) (0, $brn6e.getEmojiFromEmojiId)({
            userId: userId,
            cloudId: cloudId,
            emojiId: emojiId
        }).then((emoji)=>{
            emoji && setSavedEmoji(emoji);
            emoji && setSelectedEmojiCallback(emoji);
        });
        else setSelectedEmojiCallback(null);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasEmoji,
        emojiId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isLivePage && hasEmoji && emojiId && emojiId !== (0, $8rneB.DefaultTitleEmojiValues).LIVE_PAGE_DEFAULT && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) emojiTitleState.setPreviousEmojiId(contentId, emojiId);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLivePage,
        hasEmoji,
        emojiId,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, defaulTitleEmojiMutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: defaulTitleEmojiMutationError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a23949174eb14aa$export$d1f4a31666fe9f85), {
        key: "editor-emoji-title",
        contentId: contentId,
        aifcSuggestionInFlight: aifcSuggestionInFlight,
        aiSuggestedEmojiId: aiSuggestedEmojiId,
        isSmartCreate: isSmartCreate,
        aiEmojiSuggestionSource: aiEmojiSuggestionSource,
        aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId,
        currentEmojiId: emojiId,
        floatingToolbarButtonStyle: floatingToolbarButtonStyle,
        isLoading: updateEmojiLoading || emojiTitleState.state.isRemovingEmoji || updateDefaultTitleEmojiLoading,
        setOpenSecondEmojiPicker: emojiTitleState.setOpenSecondEmojiPicker,
        openSecondEmojiPicker: emojiTitleState.state.openSecondEmojiPicker,
        setIsEmojiButtonFocused: emojiTitleState.setIsEmojiButtonFocused,
        userOffline: disableEmoji,
        emojiPicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AV9gd.EmojiPickerLoader), {
            contentId: contentId,
            onUpdateStartEmoji: onUpdateStartEmoji,
            emojiTitleState: emojiTitleState,
            onEmojiUpdated: refetchEmoji,
            onUpdateEndEmoji: onUpdateEndEmoji,
            updateContentProperty: updateContentProperty,
            closeBothEmojiPicker: closeBothEmojiPicker,
            componentName: "EmojiTitleButton",
            aiSuggestedEmojiId: aiSuggestedEmojiId,
            isSmartCreate: isSmartCreate,
            hasReplacedAIFCEmojiRef: hasReplacedAIFCEmojiRef,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId
        }),
        onEmojiPickerLoaded: onEmojiPickerLoaded,
        hasEmoji: hasEmoji && !!savedEmoji,
        onRemoveEmoji: removeEmojiCallback,
        updateDefaultEmoji: updateDefaultEmoji,
        hasLiveDocsDefaultEmoji: hasDefaultTitleEmoji,
        autoPageEmojiCohort: autoPageEmojiCohort,
        emojiTitleDiscovered: emojiTitleDiscovered,
        contentType: contentType ?? undefined,
        previousEmojiId: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji') ? emojiTitleState.getPreviousEmojiId(contentId) : null,
        restorePreviousEmoji: restorePreviousEmoji
    }));
};
const $edc85dfc7a3f85c2$var$EmojiTitleButtonWithPTSU = (0, $ecUYt.withPageTreeStateUpdater)($edc85dfc7a3f85c2$var$EmojiTitleButtonComponent);
const $edc85dfc7a3f85c2$export$9aed4ea8e0e8c381 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $ktUCG.EmojiTitleStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($edc85dfc7a3f85c2$var$EmojiTitleButtonWithPTSU, {
                ...props,
                emojiTitleState: emojiTitleState,
                "data-testid": "emoji-title-button"
            }));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["EmojiWrapper"] = $edc85dfc7a3f85c2$export$e31a6cc0a4c97f0e;
module.exports["EmojiTitleButton"] = $edc85dfc7a3f85c2$export$9aed4ea8e0e8c381;

});

parcelRegister("ecUYt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("AV9gd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cb0f340ec70ce939$export$ece7683bd8712e82 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "q1NFz",
    name: "EmojiPickerLoader",
    loader: async ()=>(await (parcelRequire("8M30J"))).EmojiPicker
});
module.exports["EmojiPickerLoader"] = $cb0f340ec70ce939$export$ece7683bd8712e82;

});

parcelRegister("8M30J", function(module, exports) {

let $6635244a08cd6b4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6635244a08cd6b4e$var$load("lVrrs"),
    $6635244a08cd6b4e$var$load("3NkiL"),
    $6635244a08cd6b4e$var$load("s4822"),
    $6635244a08cd6b4e$var$load("XgRtr")
]).then(()=>parcelRequire('aQXpZ'));

});

parcelRegister("f0NfR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

function $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a(WrappedComponent) {
    function WithSessionData(props) {
        const sessionData = (0, $bQm3c.useSessionData)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            sessionData: sessionData,
            ...props
        });
    }
    WithSessionData.displayName = `withSessionData(${WrappedComponent.displayName || WrappedComponent.name})`;
    return WithSessionData;
}
module.exports["withSessionData"] = $b5f8b5d5e877d1bc$export$86eb994f9cd7d13a;

});

parcelRegister("gxtki", function(module, exports) {
function $249d0e770ebf7c87$export$4163f075d4b10c85(mutationErrors) {
    return mutationErrors.map((e)=>({
            ...e,
            // The Array check normalizes the fact that the GraphQL schema
            // can differ at __runtime__ between AGG and cc-graphql.
            extensions: Array.isArray(e.extensions) ? e.extensions : e.extensions != null ? [
                e.extensions
            ] : undefined
        }));
}
module.exports["mutationErrorExtensionsAggCompat"] = $249d0e770ebf7c87$export$4163f075d4b10c85;

});


//# sourceMappingURL=EmojiTitleButton.af2a9b5e.js.map
